import { render, staticRenderFns } from "./page-edit-table-drag.vue?vue&type=template&id=6f10c2e9"
import script from "./page-edit-table-drag.vue?vue&type=script&setup=true&lang=js"
export * from "./page-edit-table-drag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./page-edit-table-drag.vue?vue&type=style&index=0&id=6f10c2e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports